/** Personnel event colours. They identify people, so they stay outside the brand theme. */
export const PERSONNEL_COLOR_PALETTE = [
  "#3d4c5c",
  "#5c6b7a",
  "#6e5848",
  "#4e6a62",
  "#7a624e",
  "#3f5a68",
  "#6a5a68",
  "#4a5560",
  "#5e6e58",
  "#6b5e52",
];

/** Flights stay on the travel token, not a brand colour. */
export const FLIGHT_COLOR = "var(--travel)";
